import React, { useEffect, useState } from "react";
import { convertLocalDate } from "../../Utils/configController";
import * as url from "../../helpers/url_helper";
import { useParams } from "react-router-dom";
import ReactDataTable from "../../components/Common/ReactDataTable";
import { Card, CardBody } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useSocket } from "../../Utils/socket";
import { OPERATE_MQTT } from "../../helpers/socketEvent";
import { FormatJsonCheckBox } from "../../components/Common/button";

const DebugDetail = () => {
  const socket: any = useSocket();
  const { slave } = useParams();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const [isReload, setReload] = useState(false);
  const [showFormatted, setShowFormatted] = useState<boolean>(false);
  const [txCount, setTxCount] = useState<number>(0);
  const [rxCount, setRxCount] = useState<number>(0);
  const [cmdCounts, setCmdCounts] = useState({});

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const columns = [
    {
      name: "Command",
      cell: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          const cmd = parsed.cmd ? parsed.cmd : "-";

          const isTX = row.topic.includes("/TX") || row.topic.includes("/g2m");
          const isRX = row.topic.includes("/RX") || row.topic.includes("/m2g");

          const textColor = isTX ? "green" : isRX ? "orange" : "inherit";

          return <div style={{ color: textColor }}>{cmd}</div>;
        } catch (e) {
          return "-";
        }
      },
      selector: (row: any) => {
        try {
          const parsed = JSON.parse(row?.command);
          return parsed.cmd || "";
        } catch (e) {
          return "";
        }
      },
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: `TX (${txCount})`,
      cell: (row: any) => {
        const isDevice =
          row.topic.includes("/TX") || row.topic.includes("/g2m");
        const content = isDevice
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
              lineHeight: "1.4",
              fontSize: "14px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },
    {
      name: `RX (${rxCount})`,
      cell: (row: any) => {
        const isMobile =
          row.topic.includes("/RX") || row.topic.includes("/m2g");
        const content = isMobile
          ? showFormatted
            ? formatCommand(row.command)
            : row.command
          : "-";
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              padding: "10px 2px",
            }}
          >
            {content}
          </div>
        );
      },
      wrap: true,
      grow: 2,
    },

    {
      name: "Created At",
      selector: (row: any) => row.createdAt, // raw date value
      sortable: true,
      format: (row: any) => convertLocalDate(row.createdAt), // formatted display
      wrap: true,
    },
  ];

  const formatCommand = (command: string) => {
    try {
      return JSON.stringify(JSON.parse(command), null, 2);
    } catch {
      return command;
    }
  };

  const handlePG = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${slave}`);
    }
  };

  const handleDS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DS",
      };

      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DS sent to slave ${slave}`);
    }
  };
  const handleDL = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "DL",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`DL sent to slave ${slave}`);
    }
  };
  const handleSS = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "SS",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`SS sent to slave ${slave}`);
    }
  };
  const handleReboot = () => {
    if (slave !== undefined) {
      const reqObj = {
        slave: slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "HW",
        sub_cmd: "reboot",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Reboot sent to slave ${slave}`);
    }
  };
  return (
    <>
      <ToastContainer />
      <Card
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
        }}
      >
        <CardBody>
          <div className="d-flex flex-wrap justify-content-start align-items-center gap-3">
            <button className="btn btn-dark" onClick={handlePG}>
              PG
            </button>
            <button className="btn btn-dark" onClick={handleDS}>
              DS
            </button>
            <button className="btn btn-dark" onClick={handleDL}>
              DL
            </button>
            <button className="btn btn-dark" onClick={handleSS}>
              SS
            </button>
            <button className="btn btn-dark" onClick={handleReboot}>
              Reboot
            </button>
          </div>
        </CardBody>
      </Card>

      <ReactDataTable
        apiURL={`${url.BASE_URL}${url.DEBUG_DETAIL_LIST}`}
        paramsId={{ slave: slave }}
        columns={columns}
        isReload={isReload}
        setTxCount={setTxCount}
        setRxCount={setRxCount}
        setCmdCounts={setCmdCounts}
        cmdList={
          <div
            className="d-flex flex-wrap"
            style={{ gap: "12px", fontSize: "16px" }}
          >
            {Object.entries(cmdCounts as { [key: string]: number })
              ?.sort(([a], [b]) => {
                if (a === "ERROR") return 1;
                if (b === "ERROR") return -1;
                if (a === "NO CMD") return 1;
                if (b === "NO CMD") return -1;
                return a.localeCompare(b);
              })
              ?.map(([cmd, count], i) => (
                <div
                  key={`${cmd}-${i}`}
                  className={`d-flex justify-content-center align-items-center border gap-2 px-2 py-2 ${
                    cmd === "ERROR"
                      ? "bg-danger text-white rounded"
                      : "bg-light rounded"
                  }`}
                  style={{
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                  }}
                >
                  <small className="text-uppercase fw-semibold">
                    {cmd === "ERROR" ? "ERRORS" : cmd}
                  </small>
                  <span className="badge bg-primary rounded-pill ">
                    {count}
                  </span>
                </div>
              ))}
          </div>
        }
        buttonformatJSON={
          <FormatJsonCheckBox
            checked={showFormatted}
            onChange={() => setShowFormatted(!showFormatted)}
          />
        }
      />
    </>
  );
};

export default DebugDetail;
